import { createAction, createSlice } from "@reduxjs/toolkit";

const externalLoginSlice = createSlice({
  name: "externalLogin",
  initialState: { data: null, processing: false },
  reducers: {
    pending(state) {
      state.processing = true;
      /* TODO: reducer for pending*/
    },
    success(state) {
      state.processing = false;
      /* TODO: reducer for success*/
    },
    failure(state) {
      state.processing = false;
      /* TODO: reducer for failure*/
    },
  },
});

const { name, actions, reducer } = externalLoginSlice;
const externalLoginAction = createAction(name);

export {
  externalLoginAction,
  actions as externalLoginActions,
  reducer as externalLoginReducer,
};
